export const environment = {
  production: false,
  instrumentationKey: "",
  apiUrl: "https://wtv-api-dev-cvx.azurewebsites.net"
};
